export default "__VITE_ASSET__7uE6ZrU0__"